/** Mode de facturation d'une phase ou d'une ligne vendue. */
export type BillingMethod =
  | 'forfait_brique'
  | 'forfait_global'
  | 'forfait_echelonne'
  | 'regie_temporelle'
  | 'regie_horaire'
  | 'maintenance_corrective'
  | 'maintenance_evolutive'
  | 'hebergement';
export const BILLING_LABELS: Record<BillingMethod, string> = {
  forfait_brique: 'Forfait par brique',
  forfait_global: 'Forfait global',
  forfait_echelonne: 'Forfait échelonné',
  regie_temporelle: 'Régie',
  regie_horaire: 'Régie horaire',
  maintenance_corrective: 'Maintenance corrective',
  maintenance_evolutive: 'Maintenance évolutive',
  hebergement: 'Hébergement',
};
// Méthodes de facturation proposées sur une affaire (modèle projet + hébergement, revenu récurrent).
export const DEAL_BILLING_OPTIONS: BillingMethod[] = [
  'forfait_brique',
  'forfait_global',
  'forfait_echelonne',
  'regie_temporelle',
  'regie_horaire',
  'maintenance_corrective',
  'maintenance_evolutive',
  'hebergement',
];
// Types à revenu récurrent (montant mensuel, étalé sur la durée du contrat) — comptés au prorata
// des mois de l'année. La régie facture au réel mois après mois comme la maintenance/l'hébergement
// (décision du 2026-09-02) : seuls forfait_brique et forfait_global restent "one-shot", posés
// intégralement sur l'année de décision (date de passage à "Devis accepté").
export const RECURRING_BILLING: readonly string[] = [
  'maintenance_corrective',
  'maintenance_evolutive',
  'hebergement',
  'regie_temporelle',
  'regie_horaire',
  'forfait_echelonne',
];
// Forfait échelonné (arbitrage du 2026-10-02) : un montant total payé en N mensualités (ex.
// 31 800 € sur 60 mois = 530 €/mois). Son CA se répartit mois par mois comme un récurrent, mais
// le contrat s'arrête à la dernière mensualité : pas de reconduction tacite, ni jours ni TJM exigés.
export const INSTALLMENT_BILLING = 'forfait_echelonne';
// Régie horaire : heures achetées par mois ou par an.
export type HourlyUnit = 'heures_mois' | 'heures_an';

// Unités possibles pour le volume vendu d'une ligne de maintenance (corrective ou évolutive) :
// purement informatif (suivi de consommation vs tickets Jira), sans impact sur le CA.
/** Unité du volume vendu sur une ligne de maintenance. */
export type VolumeUnit = 'jours_mois' | 'heures_mois' | 'jours_an' | 'heures_an';
export const VOLUME_UNITS: VolumeUnit[] = ['jours_mois', 'heures_mois', 'jours_an', 'heures_an'];
export const VOLUME_UNIT_LABELS: Record<VolumeUnit, string> = {
  jours_mois: 'jours/mois',
  heures_mois: 'heures/mois',
  jours_an: 'jours/an',
  heures_an: 'heures/an',
};
